import axiosInstanceNew from "../lib/axiosinstanceNew";

const EhcReport = class {

    constructor(){
        this.baseUrl="ehc_report";
    }

  async ListByClassId(id) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?class_id=${id}`));
  }
  async Add(data=[]) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
  async ListByClassIdStudentId(id, iid) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?class_id=${id}&student_id=${iid}`));
  }
}

export default new EhcReport();